import type { ComponentProps } from 'react';
import { type VariantProps, cva } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-badge px-1.5 py-px text-tab font-semibold',
  {
    variants: {
      variant: {
        outline: 'border border-line text-fg-muted',
        solid: 'bg-accent text-accent-fg',
      },
    },
    defaultVariants: { variant: 'outline' },
  },
);

export function Badge({
  className,
  variant,
  ...props
}: ComponentProps<'span'> & VariantProps<typeof badgeVariants>) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}
